import styled from 'styled-components';

export const SelectFieldsContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  
  span {
    white-space: nowrap;
  }
`

export const MarkersLabel = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  margin-right:20px;
`

export const RadioExtraContainer = styled.div`
  display: flex;
  align-items: flex-start;
`